import type { TContractDurationUnit } from "@bbj-types/offer";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useModalOfferContext } from "../../context";
import { requiredForContractType } from "../../logics/logics";
import { ContractDurationStack, classes } from "./styles";

interface IUnit {
  label: string;
  value: string;
}
const unit: IUnit[] = [
  { label: "Jours", value: "day" },
  { label: "Semaines", value: "week" },
  { label: "Mois", value: "month" },
  { label: "Années", value: "year" },
];

export const ContractDurationInput = () => {
  const { offer, setOffer, disabled, errors, setErrors, applyFollowUp, apply } = useModalOfferContext();
  const required = applyFollowUp && apply.status === "success";

  return (
    <ContractDurationStack className={classes.root}>
      <TextField
        label={required && requiredForContractType(offer) ? "Durée*" : "Durée"}
        type="number"
        size="small"
        className={classes.duration}
        value={offer?.contractDuration?.duration ?? ""}
        error={!!errors.contractDurationValue}
        onChange={(evt) => {
          setOffer((offer) => ({
            ...offer,
            contractDuration: { unit: "month", ...offer.contractDuration, duration: Number.parseInt(evt.target.value) },
          }));
          setErrors((errors) => ({ ...errors, contractDurationValue: false }));
        }}
        disabled={disabled}
        slotProps={{
          htmlInput: { min: 0 },
        }}
      />
      <FormControl className={classes.unit} error={!!errors.contractDurationUnit}>
        <InputLabel id="contract-duration-period-select" size="small" disabled={disabled}>
          {required && requiredForContractType(offer) ? "Unité*" : "Unité"}
        </InputLabel>
        <Select
          labelId="contract-duration-period-select"
          id="contract-duration-period"
          size="small"
          label="Mois"
          defaultValue=""
          value={offer?.contractDuration?.unit ?? ""}
          error={!!errors.contractDurationUnit}
          onChange={(evt) => {
            setOffer((offer) => ({
              ...offer,
              contractDuration: { ...offer.contractDuration, unit: evt.target.value as TContractDurationUnit },
            }));
            setErrors((errors) => ({ ...errors, contractDurationUnit: false }));
          }}
          disabled={disabled}
          MenuProps={{
            sx: {
              "& .MuiPopover-paper": {
                m: 0,
                p: 0,
              },
            },
          }}
        >
          {unit.map((unit) => (
            <MenuItem key={unit.label} value={unit.value}>
              {unit.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ContractDurationStack>
  );
};
